const FooterPlaceholder = () => {
  const updatePlaceholder = (emailInput, placeholderText) => {
    // Create a temporary canvas element to measure the width of the placeholder's text  
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    context.font = window.getComputedStyle(emailInput).font;
    const placeholderWidth = context.measureText(placeholderText + "...").width;

    // Measure the width of the input without left/right paddings
    const inputStyles = window.getComputedStyle(emailInput);
    const paddingLeft = parseFloat(inputStyles.paddingLeft);
    const paddingRight = parseFloat(inputStyles.paddingRight);
    const inputWidthWithoutPadding = emailInput.getBoundingClientRect().width - paddingLeft - paddingRight;

    if (placeholderWidth > inputWidthWithoutPadding) {
      let trimmedText = placeholderText;
      while (context.measureText(trimmedText + "...").width > inputWidthWithoutPadding && trimmedText.length > 0) {
        trimmedText = trimmedText.slice(0, -1);
      }
      emailInput.placeholder = trimmedText + "...";
    } else {
      emailInput.placeholder = placeholderText;
    }
  };

  const footerForms = document.querySelectorAll(".footer__form");

  if (footerForms.length > 0) {
    footerForms.forEach((footerForm) => {
      const emailInput = footerForm.querySelector(".footer__input");
      const placeholderText = emailInput.getAttribute("placeholder");

      const handleResize = () => {
        updatePlaceholder(emailInput, placeholderText);
      };

      updatePlaceholder(emailInput, placeholderText);
      window.addEventListener("resize", handleResize);
    });
  }
}

export default FooterPlaceholder;

// const FooterPlaceholder = () => {
//   const updatePlaceholder = (emailInput, placeholderText) => {
//     // Create a temporary canvas element to measure the width of the placeholder's text  
//     const canvas = document.createElement('canvas');
//     const context = canvas.getContext('2d');

//     context.font = window.getComputedStyle(emailInput).font;
//     const placeholderWidth = context.measureText(placeholderText).width;

//     // Measure the width of the input without left/right paddings
//     const inputStyles = window.getComputedStyle(emailInput);
//     const paddingLeft = parseFloat(inputStyles.paddingLeft);
//     const paddingRight = parseFloat(inputStyles.paddingRight);
//     const inputWidthWithoutPadding = emailInput.getBoundingClientRect().width - paddingLeft - paddingRight;

//     if (placeholderWidth > inputWidthWithoutPadding) {
//       emailInput.placeholder = "Your email address";
//     } else {
//       emailInput.placeholder = placeholderText;
//     }
//   };

//   const footerForms = document.querySelectorAll(".footer__form");

//   if (footerForms.length > 0) {
//     footerForms.forEach((footerForm) => {
//       const emailInput = footerForm.querySelector(".footer__input");
//       const placeholderText = emailInput.getAttribute("placeholder");

//       const handleResize = () => {
//         updatePlaceholder(emailInput, placeholderText);
//       };

//       updatePlaceholder(emailInput, placeholderText);
//       window.addEventListener("resize", handleResize);
//     });
//   }
// }

// export default FooterPlaceholder;
